/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_ClaimsInputs */

const en_home_footer_link_claims = /** @type {(inputs: Home_Footer_Link_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a Claim`)
};

const fr_home_footer_link_claims = /** @type {(inputs: Home_Footer_Link_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire une réclamation`)
};

/**
* | output |
* | --- |
* | "Make a Claim" |
*
* @param {Home_Footer_Link_ClaimsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_claims = /** @type {((inputs?: Home_Footer_Link_ClaimsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_ClaimsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_claims(inputs)
	return fr_home_footer_link_claims(inputs)
});